import React, { memo, useEffect, useState } from 'react';
import Button from '../components/common/UI/Inputs/Button';
import errorimg from '../assets/images/404.png';
import logo from '../assets/images/logo-gray.png';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { masterActions } from '../_store';
const ErrorPage = () => {
  const dispatch = useDispatch();
  const loginInterval = 60000; // 1 minute
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();


  const handleLoginFromMaintenance = () => {
    dispatch(masterActions.GetApplicationSettings("WEB"))
      .then((result) => {
        const data = result?.payload;
        if (
          Object?.keys(data).length === 0 ||
          data?.IsApplicationMaintenance === 1
        ) {
          navigate("/public/Maintenance");
          return;
        }
        if (data && data?.IsApplicationMaintenance === 0) {
          navigate("/");
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log("Error API");
      });
  };

  // Check maintenance every X seconds + online/offline listeners
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (navigator.onLine) handleLoginFromMaintenance();
    }, loginInterval);

    // Update UI when internet status changes
    const handleOnline = () => {
      setIsOnline(true);
      handleLoginFromMaintenance(); // immediately retry
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div className="parent-container">
      {isOnline ? (
        /* ---------------- ONLINE UI ---------------- */
        <div className="error-container">
          <div className="error-logo">
            <img src={logo} alt="Logo" />
          </div>
          <div className="error-content">
            <div className="error-code">
              <img src={errorimg} alt="Logo" />
            </div>
            <p className="error-message">
              {"The server encountered an internal error and was unable to process your request. Please try again later, or contact your administrator if the problem persists."}
            </p>
            <div className="d-flex justify-content-center mt-3">
              <Button
                variant="primary"
                className="me-2"
                onClick={handleLoginFromMaintenance}
                label="BACK TO LOGIN"
                type="button"
                status="primary"
              />
            </div>
          </div>
          <div className="error-footer">
            <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
          </div>
        </div>
      ) : (
        /* ---------------- OFFLINE UI ---------------- */
        <div>
          <div className="maintance-content shadow-sm b-r-all">
            <h1 className="header-title">No internet connection</h1>

            <p className="maintance-text">
              Oops! It looks like your internet connection has been lost.
              Please check your connection and try again.
            </p>

            <div className="d-flex justify-content-center">
              <Button
                variant="primary"
                className="mt-2"
                onClick={handleLoginFromMaintenance}
                label="RETRY"
                type="button"
                status="primary"
              />
            </div>
          </div>

          <div className="maintance-footer">
            <p>
              Copyright © {new Date().getFullYear()} by inmate inbox.
              All Rights Reserved.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ErrorPage);

